module.exports = __webpack_public_path__ + "img/home4.123eb16b.png";